import memorize from './memorize'

export default memorize((p, prefix = '$') => {
  const pStr = String(p)
  return prefix + pStr.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
})
